(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/slide-indicator.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/slide-indicator.js');
"use strict";

const _React = React,
  useMemo = _React.useMemo;
const _svs$ui$ReactNavigati = svs.ui.ReactNavigationIndicator,
  NavigationIndicator = _svs$ui$ReactNavigati.NavigationIndicator,
  NavigationIndicatorDot = _svs$ui$ReactNavigati.NavigationIndicatorDot,
  NavigationIndicatorPrev = _svs$ui$ReactNavigati.NavigationIndicatorPrev,
  NavigationIndicatorNext = _svs$ui$ReactNavigati.NavigationIndicatorNext;
const SlideIndicator = _ref => {
  let totalCount = _ref.totalCount,
    activeSlide = _ref.activeSlide,
    setActiveSlide = _ref.setActiveSlide,
    isNextDisalbed = _ref.isNextDisalbed,
    nextSlide = _ref.nextSlide,
    isPrevDisalbed = _ref.isPrevDisalbed,
    prevSlide = _ref.prevSlide,
    branding = _ref.branding;
  const dotsArr = useMemo(() => {
    const dots = new Array(totalCount).fill(null);
    return dots.map((_, index) => {
      const dotIndex = index;
      return React.createElement(NavigationIndicatorDot, {
        isActive: activeSlide === dotIndex,
        key: dotIndex,
        onClick: () => {
          setActiveSlide(dotIndex);
        }
      });
    });
  }, [totalCount, activeSlide, setActiveSlide]);
  return React.createElement(NavigationIndicator, {
    branding: branding
  }, React.createElement(NavigationIndicatorPrev, {
    branding: branding,
    disabled: isPrevDisalbed,
    onClick: prevSlide
  }), dotsArr, React.createElement(NavigationIndicatorNext, {
    branding: branding,
    disabled: isNextDisalbed,
    onClick: nextSlide
  }));
};
setGlobal('svs.components.onboarding.slides.SlideIndicator', SlideIndicator);

 })(window);